import React from 'react';
import Image from 'next/image';
// const SecretsSecurityTimeline = () => {
//   // Configuration - fully editable
//   const config = {
//     // Canvas dimensions
//     canvas: {
//       width: 700,
//       height: 160,
//       backgroundColor: 'transparent' // Change if you want a background color
//     },
    
//     // Title configuration
//     title: {
//       text: "Secrets security",
//       x: 10,             // Horizontal position
//       y: 0,             // Vertical position
//       fontSize: 20,      // Font size in pixels
//       fontWeight: 'regular',// Font weight
//       color: '#004000'   // Text color
//     },
    
//     // Timeline base configuration
//     timeline: {
//       y: 100,            // Vertical position
//       startX: 20,        // Starting x-coordinate
//       endX: 650,         // Ending x-coordinate
//       height: 2,         // Line thickness
//       color: 'black'     // Line color
//     },
    
//     // Year markers configuration
//     yearMarkers: {
//       tickHeight: 6,     // Height of the tick mark
//       tickWidth: 1,      // Width of the tick mark
//       labelOffset: { x: -10, y: -18 }, // Position offset for labels
//       fontSize: 12,      // Font size for year labels
//       color: 'black',    // Color for tick marks
//       labelColor: '#333' // Color for year labels
//     },
    
//     // Years data - each with position
//     years: [
//       { label: "2025", x: 20 },
//       { label: "2026", x: 220 },
//       { label: "2027", x: 420 },
//       { label: "2028 (racing)", x: 620 }
//     ],
    
//     // Blue SSL entries (top)
//     blueSSLs: [
//       { 
//         label: "OpenBrain\nSSL 1", 
//         x: 55,          // Horizontal position
//         y: 35,           // Vertical position
//         lineWidth: 0,    // Line width
//         color: '#0000aa',// Color for both text and line
//         labelWidth: 80,  // Width of the label area
//         fontSize: 12,     // Font size for the label
//         isFirst: true
//       },
//       { label: "SSL 2", x: 240, y: 55, lineWidth: 1, color: '#0000aa', labelWidth: 80, fontSize: 12 },
//       { label: "SSL 3", x: 440, y: 55, lineWidth: 1, color: '#0000aa', labelWidth: 80, fontSize: 12 },
//       { label: "SSL 4", x: 520, y: 55, lineWidth: 1, color: '#0000aa', labelWidth: 80, fontSize: 12 },
//       { label: "SSL 5", x: 640, y: 55, lineWidth: 1, color: '#0000aa', labelWidth: 80, fontSize: 12 }
//     ],
    
//     // Red SSL entries (bottom)
//     redSSLs: [
//       { 
//         label: "SSL 0\nDeepCent", 
//         x: 55,           // Horizontal position
//         y: 120,          // Vertical position
//         lineHeight: 20,  // Height of the vertical line
//         lineWidth: 0,    // Width of the line
//         color: '#aa0000',// Color for both text and line
//         labelWidth: 80,  // Width of the label area
//         fontSize: 12,     // Font size for the label
//         isFirst: true
//       },
//       { label: "SSL 1", x: 280, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 },
//       { label: "SSL 2", x: 390, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 },
//       { label: "SSL 3", x: 450, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 },
//       { label: "SSL 4", x: 530, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 },
//       { label: "SSL 5", x: 650, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 }
//     ]
//   };

//   return (
//     <div 
//       className="relative font-mono" 
//       style={{ 
//         width: config.canvas.width, 
//         height: config.canvas.height,
//         backgroundColor: config.canvas.backgroundColor
//       }}
//     >
//       {/* Title */}
//       <div 
//         className="absolute"
//         style={{ 
//           left: config.title.x, 
//           top: config.title.y,
//           fontSize: `${config.title.fontSize}px`,
//           fontWeight: config.title.fontWeight,
//           color: config.title.color
//         }}
//       >
//         {config.title.text}
//       </div>
      
//       {/* Main horizontal timeline */}
//       <div 
//         className="absolute" 
//         style={{ 
//           left: config.timeline.startX, 
//           top: config.timeline.y, 
//           width: config.timeline.endX - config.timeline.startX, 
//           height: config.timeline.height,
//           backgroundColor: config.timeline.color
//         }}
//       ></div>
      
//       {/* Year markers */}
//       {config.years.map((year, i) => (
//         <div key={`year-${i}`} className="absolute" style={{ left: year.x, top: config.timeline.y-5 }}>
//           {/* Year tick mark */}
//           <div 
//             className="absolute" 
//             style={{ 
//               left: 0, 
//               top: 0, 
//               width: config.yearMarkers.tickWidth, 
//               height: config.yearMarkers.tickHeight,
//               backgroundColor: config.yearMarkers.color
//             }}
//           ></div>
          
//           {/* Year label */}
//           <pre 
//             className="absolute" 
//             style={{ 
//               left: config.yearMarkers.labelOffset.x-4, 
//               top: config.yearMarkers.labelOffset.y,
//               fontSize: `${config.yearMarkers.fontSize}px`,
//               color: config.yearMarkers.labelColor
//             }}
//           >{year.label}</pre>
//         </div>
//       ))}
      
//       {/* Blue SSL markers (top) */}
//       {config.blueSSLs.map((SSL, i) => (
//         <div key={`blue-${i}`} className="absolute" style={{ left: SSL.x, top: SSL.y }}>
//           {/* Text label */}
//           <pre 
//             className="absolute whitespace-pre text-center" 
//             style={{ 
//               color: SSL.color, 
//               left: -(SSL.labelWidth/2), 
//               top: 0, 
//               width: SSL.labelWidth,
//               fontSize: `${SSL.fontSize}px`,
//               textAlign: SSL.isFirst ? 'left' : 'center'
//             }}
//           >{SSL.label}</pre>
          
//           {/* Vertical line */}
//           <div 
//             className="absolute" 
//             style={{ 
//               backgroundColor: SSL.color, 
//               left: 0, 
//               top: SSL.fontSize * (SSL.label.split('\n').length + 1), // Adjust based on label height
//               width: SSL.lineWidth, 
//               height: config.timeline.y - SSL.y - (SSL.fontSize * (SSL.label.split('\n').length + 1))
//             }}
//           ></div>
//         </div>
//       ))}
      
//       {/* Red SSL markers (bottom) */}
//       {config.redSSLs.map((SSL, i) => (
//         <div key={`red-${i}`} className="absolute" style={{ left: SSL.x, top: SSL.y }}>
//           {/* Vertical line */}
//           <div 
//             className="absolute" 
//             style={{ 
//               backgroundColor: SSL.color, 
//               left: 0, 
//               top: -SSL.lineHeight, 
//               width: SSL.lineWidth, 
//               height: SSL.lineHeight
//             }}
//           ></div>
          
//           {/* Text label */}
//           <pre 
//             className="absolute whitespace-pre text-center" 
//             style={{ 
//               color: SSL.color, 
//               left: -(SSL.labelWidth/2), 
//               top: 0, 
//               width: SSL.labelWidth,
//               fontSize: `${SSL.fontSize}px`,
//               textAlign: SSL.isFirst ? 'left' : 'center'
//             }}
//           >{SSL.label}</pre>
//         </div>
//       ))}
//     </div>
//   );
// };

const SecretsSecurityTimeline = () => {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img src="/secrets-security-timeline.png" alt="Secrets security timeline" className="w-[100%] h-[100%]" />
  )
}

export default SecretsSecurityTimeline;